"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.desktop_search_item_img = exports.search__img = exports.new__review__star = exports.desktop_auto_comp_imgExpand = exports.desktop_auto_comp_img = exports.recom_detail_button_img = exports.best_average_score = exports.top__keyvisul__link__icon = void 0;
const URL = "https://dcicons.s3.ap-northeast-1.amazonaws.com/new/images/web/react_components/indexPage";
const M_URL = "https://dcicons.s3.ap-northeast-1.amazonaws.com/new/images/mobile";
exports.top__keyvisul__link__icon = `${URL}/top__keyvisul__link__icon.png`;
exports.best_average_score = `${URL}/best_average_score.png`;
exports.recom_detail_button_img = `${URL}/recom_detail_button_img.png`;
exports.desktop_auto_comp_img = `${URL}/desktop_auto_comp_img.png`;
exports.desktop_auto_comp_imgExpand = `${URL}/desktop_auto_comp_imgExpand.png`;
exports.new__review__star = `${M_URL}/common_react/review__newstar__img.png`;
exports.search__img = `${M_URL}/indexPage/header_search.png`;
exports.desktop_search_item_img = `${URL}/Search__Item__Icon.png`;
